// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 20:59:37

export default {
  "id": "stick-color-war",
  "slug": "stick-color-war",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/faea0792fe9b48feb2294cb595a883df-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/faea0792fe9b48feb2294cb595a883df/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Stick - Color War",
      "description": "To defeat enemies you must shoot bullets of the same color as the enemy. \nEvery five levels you have to defeat a boss.\nBreaking off new weapons.\nWill you be able to resist the colored sticks?\nPlay our shooter without downloads and registration.\n",
      "instructions": "Management:\n\nOn mobile devices:\nUse the buttons on the phone screen.\n\nOn PC:\nLeft mouse button - aim and shoot.",
      "genres": [
        "Shooter"
      ],
      "tags": [
        "color",
        "guns",
        "stickman",
        "timekiller"
      ]
    },
    "zh-CN": {
      "title": "棍棒 - 颜色战",
      "description": "要击败敌人，你必须射击与敌人颜色相同的子弹。\n每五级你需要击败一个Boss。\n解锁新武器。\n你能否抵御彩色棍棒？\n无需下载和注册，玩我们的射击游戏。",
      "instructions": "管理：\n\n在移动设备上：\n使用手机屏幕上的按钮。\n\n在PC上：\n左鼠标按钮 - 瞄准和射击。",
      "genres": [
        "射击类游戏"
      ],
      "tags": [
        "颜色",
        "枪械",
        "小丑人",
        "时间杀手"
      ]
    },
    "zh-TW": {
      "title": "棒 - 颜色戰",
      "description": "要擊敗敵人，您必須射擊與敵人同色的子彈。\n每五個等級，您必須擊敗一個大魔王。\n開啟新武器的道路。\n您能夠抗拒彩色木棍的誘惑嗎？\n免下載免註冊，遊玩我們的射擊遊戲。",
      "instructions": "管理：\n\n在行動裝置上：\n使用手機屏幕上的按鈕。\n\n在電腦上：\n左鍵鼠標 - 對準和射擊。",
      "genres": [
        "射手"
      ],
      "tags": [
        "顏色",
        "槍械",
        "獨立小人",
        "時間消磨者"
      ]
    },
    "zh-HK": {
      "title": "棒 - 颜色戰爭",
      "description": "為了擊敗敵人，你必須射擊與敵人同色的小球。\n每五關你必須擊敗一個BOSS。\n開啟新武器的路徑。\n你能夠抗拒這些彩色的棒子嗎？\n免下載及註冊，遊戲我們的射擊遊戲。",
      "instructions": "管理：\n\n在移動裝置上：\n使用手機螢幕上的按鈕。\n\n在電腦上：\n左鍵鼠標 - 定位及射擊。",
      "genres": [
        "射手"
      ],
      "tags": [
        "顏色",
        "槍械",
        "小人",
        "時間殺手"
      ]
    },
    "ja": {
      "title": "スティック - カラーウォー",
      "description": "敵を倒すには、敵と同じ色の弾を撃つ必要があります。\n5レベルごとにボスを倒す必要があります。\n新しい武器を解放します。\n色の棒に耐えられるでしょうか？\nダウンロードや登録なしで当てのシューティングゲームを遊んでください。",
      "instructions": "管理：\n\nモバイルデバイス上で：\n電話の画面上のボタンを使用してください。\n\nPC上で：\n左マウスボタン - 射撃と標的を定める。",
      "genres": [
        "シューターの種類によっては以下のどれかになります。\n- シーカー・シューター（Seeker Shooter）\n- カメラ・シューターの種類によっては以下のどれかになります。\n- シングル・カメラ・シューター（Single Camera Shooter）\n- ボックス・カメラ・シューター（Box Camera Shooter）\n- カバー・シューターの種類によっては以下のどれかになります。\n- カバー・シューター（Cover Shooter）\n- カバー・オートシューターの種類によっては以下のどれかになります。\n- カバー・オートシューター（Cover Auto Shooter）"
      ],
      "tags": [
        "色",
        "銃",
        "スティックマン",
        "タイムキラー"
      ]
    },
    "ko": {
      "title": "스틱 - 컬러 워",
      "description": "적을 물리치기 위해 적과 같은 색의 탄환을 발사해야 합니다.\n한 번의 5레벨마다 보스를 물리치셔야 합니다.\n신규 무기를 획득하세요.\n색상의 막대를 저항할 수 있을까요?\n다운로드와 등록 없이我们的シュ터셔를 플레이하세요.",
      "instructions": "관리:\n\n모바일 기기에서:\n휴대폰 화면의 버튼을 사용하세요.\n\nPC에서:\n왼쪽 마우스 버튼 - 정확하게 가리키기와 쏘기.",
      "genres": [
        "射手"
      ],
      "tags": [
        "색",
        "총",
        "스티커맨",
        "타임키ラー"
      ]
    },
    "fr": {
      "title": "Épingle - Guerre des couleurs",
      "description": "Pour vaincre les ennemis, vous devez tirer des balles de la même couleur que l'ennemi.\nTous les cinq niveaux, vous devez affronter un boss.\nObtenir de nouvelles armes.\nSerez-vous capable de résister aux piques colorés ?\nJouez à notre tireur sans téléchargement ni inscription.",
      "instructions": "Gestion :\n\nSur les appareils mobiles :\nUtilisez les boutons sur l'écran du téléphone.\n\nSur PC :\nBouton gauche de la souris - viser et tirer.",
      "genres": [
        "Tirailleur d'élite"
      ],
      "tags": [
        "couleur",
        "armes",
        "stickman",
        "timekiller"
      ]
    }
  }
};
